import api from '../lib/api';
import type { Representative, RepresentativeFormData, RepresentativeFilters } from '../types/representative';

interface PaginatedResponse {
  data: Representative[];
  pagination: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
  };
}

export const representativeService = {
  async getAll(page = 1, limit = 20, filters?: RepresentativeFilters): Promise<PaginatedResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (filters?.search) {
      params.append('search', filters.search);
    }

    if (filters?.active !== undefined) {
      params.append('active', filters.active.toString());
    }

    const response = await api.get(`/mkt-representatives?${params.toString()}`);
    return response.data;
  },

  async getById(id: number): Promise<Representative> {
    const response = await api.get(`/mkt-representatives/${id}`);
    return response.data;
  },

  async create(data: RepresentativeFormData): Promise<Representative> {
    const response = await api.post('/mkt-representatives', data);
    return response.data;
  },

  async update(id: number, data: RepresentativeFormData): Promise<Representative> {
    const response = await api.put(`/mkt-representatives/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/mkt-representatives/${id}`);
  },
};
